import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import LeagueLists from '@/creditflowresearch/ui/components/league/LeagueTablePage';
import getServerSideTopCompanies from '@/creditflowresearch/application/League/serverSide/getServerSideTopCompanies';
import LeagueTableContextProvider from '@/creditflowresearch/application/League/Table/LeagueTableContext';
import withLeagueTableProps from '@/creditflowresearch/application/League/Table/withLeagueTableProps';
import { TypeCompany } from '@/creditflowresearch/application/League/constants';
import {
  ICompaniesAllState,
  IRatingAgenciesState,
  ITopRatingAgenciesState,
  ITopUnderwritersState,
  IUnderwritersState,
} from '@/creditflowresearch/application/League/interfaces';
import { getTtmFilterInitialState } from '@/creditflowresearch/application/League/helpers';
import getServerSideCompanies from '@/creditflowresearch/application/League/serverSide/getServerSideCompanies';
import LeagueTableFilterContextProvider from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';
import getServerSideLeagueTablesBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideLeagueTablesBreadcrumbs';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import PageFiltersStateContextProvider from '@/creditflowresearch/application/PageFiltersState/PageFiltersStateContext';

export const getServerSideProps = withLeagueTableProps(async (context) => {
  const [
    topUnderwritersState,
    topRatingAgenciesState,
    underwritersState,
    ratingAgenciesState,
    companiesAllState,
    breadcrumbs,
  ]:[
    ITopUnderwritersState,
    ITopRatingAgenciesState,
    IUnderwritersState,
    IRatingAgenciesState,
    ICompaniesAllState,
    IBreadcrumb[],
  ] = await Promise.all([
    getServerSideTopCompanies(TypeCompany.underwriter)(context),
    getServerSideTopCompanies(TypeCompany.ratingAgency)(context),
    getServerSideCompanies(TypeCompany.underwriter)(context),
    getServerSideCompanies(TypeCompany.ratingAgency)(context),
    getServerSideCompanies(TypeCompany.all)(context),
    getServerSideLeagueTablesBreadcrumbs(context),
  ]);
  return ({
    props: {
      topUnderwritersState,
      topRatingAgenciesState,
      underwritersState,
      ratingAgenciesState,
      companiesAllState,
      breadcrumbs,
    },
  });
});

const LeagueTable = () => (
  <PageContentLayout>
    <LeagueLists />
  </PageContentLayout>
);

export default (props) => {
  const {
    topUnderwritersState,
    topRatingAgenciesState,
    searchText,
    topUnderwritersTtmFilter,
    topRatingAgencyTtmFilter,
    companiesTtmFilter,
    underwritersState,
    ratingAgenciesState,
    companiesAllState,
  } = props;
  const ttmFilterInitState = {
    leagueTable: getTtmFilterInitialState(companiesTtmFilter),
    topUnderwriters: getTtmFilterInitialState(topUnderwritersTtmFilter),
    topRatingAgencies: getTtmFilterInitialState(topRatingAgencyTtmFilter),
  };

  return (
    <PageFiltersContextProvider>
      <PageFiltersStateContextProvider>
        <LeagueTableFilterContextProvider
          searchText={ searchText }
          ttmFilterInitState={ ttmFilterInitState }
        >
          <LeagueTableContextProvider
            topUnderwritersInitialState={ topUnderwritersState }
            topRatingAgenciesInitialState={ topRatingAgenciesState }
            underwritersInitialState={ underwritersState }
            ratingAgenciesInitialState={ ratingAgenciesState }
            companiesAllInitialState={ companiesAllState }
          >
            <LeagueTable />
          </LeagueTableContextProvider>
        </LeagueTableFilterContextProvider>
      </PageFiltersStateContextProvider>
    </PageFiltersContextProvider>
  );
};
